module.exports = __webpack_public_path__ + "assets/img/vk.f11771b4.svg";